import { render, staticRenderFns } from "./new-device-form.vue?vue&type=template&id=4df63b6a"
import script from "./new-device-form.vue?vue&type=script&lang=js"
export * from "./new-device-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4df63b6a')) {
      api.createRecord('4df63b6a', component.options)
    } else {
      api.reload('4df63b6a', component.options)
    }
    module.hot.accept("./new-device-form.vue?vue&type=template&id=4df63b6a", function () {
      api.rerender('4df63b6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Devices/new-device-form.vue"
export default component.exports